import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import moment from "moment";

//Comp Types currently:
//1 - Office Lease
//2 - Office Sale
//3 - Ind. Lease
//4 - Ind. Sale
//5 - Retail Lease
//6 - Land Sale
//7 - Multi Family

//Fields:
//1	2	3	4	5	6	7	id
//1	2	3	4	5	6	7	compType
//1	2	3	4	5	6	7	leaseCommencementYear
//1	2	3		5	6	7	leaseQuarter
//1	2	3		5	6	7	submarket
//1		3		5			tenant
//1	2	3	4	5			buildingName
//1	2	3	4	5	6	7	address
//1	2	3	4	5	6	7	city
//1	2	3	4	5	6	7	state
//1	2	3	4	5	6	7	Zip
//1		3		5			leasedSF
//1		3		5			term
//1		3		5			effectiveRate
//1		3		5			rateType
//1		3		5			TISF
//1		3		5			transactionType
//1		3		5			leaseExpDate
//1		3		5			buildingOwner
//1	2	3		5		7	buildingSize
//1	2	3	4	5		7	yearBuilt
//1	2	3	4				buildingClass
//1		3		5			tenantRepFirm
//1		3		5			landlordRepFirm
//1	2	3	4	5	6	7	comments
//1	2	3	4	5	6	7	source
//1	2	3	4	5	6	7	dateEntered
//2		4		6	7	buyer
//2		4		6	7	seller
//2		4		6	7	salePrice
//2		4				saleType
//2		4				occupancyPercent
//2		4				NOI
//2		4			7	capRate
//2		4		6	7	buyerRepFirm
//2		4		6	7	sellerRepFirm
//2	3	4		6	7	pressRelease
//3					commencementDate
//3					percentOffice
//3	4				lotSize
//3	4				ceilingHeight
//3	4				productType
//6		acres
//7	propertyName
//7	units

//Search stuff
//1	2	3	4	5	6	7	leaseCommencementFrom
//1	2	3	4	5	6	7	leaseCommencementTo
//1		3		5			LeasedSFFrom
//1		3		5			LeasedSFTo
//1	2	3	4	5			BuildingSizeFrom
//1	2	3	4	5			BuildingSizeTo
//1	2	3	4	5			YearBuiltFrom
//1	2	3	4	5			YearBuiltTo
//2		4		6		salePriceFrom
//2		4		6		salePriceTo
//2		4				perSQFTFrom
//2		4				perSQFTTo
//6		acreageFrom     
//6		acreageTo



export class CompSummary extends Component {
    static displayName = CompSummary.name;
    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const compType = params.get('compType');
        const compId = params.get('compId');

        const compsList =
            [
                { id: 1, name: "Office Lease", fileName: "OfficeLeaseSite", reportName: "OFFICE LEASE COMP" },
                { id: 2, name: "Office Sale", fileName: "OfficeSaleSite", reportName: "OFFICE SALE COMP" },
                { id: 3, name: "Industrial Lease", fileName: "IndustrialLeaseSite", reportName: "INDUSTRIAL LEASE COMP" },
                { id: 4, name: "Industrial Sale", fileName: "IndustrialSaleSite", reportName: "INDUSTRIAL SALE COMP" },
                { id: 5, name: "Retail Lease", fileName: "RetailLeaseSite", reportName: "RETAIL LEASE COMP" },
                { id: 6, name: "Retail Sale", fileName: "RetailSaleSite", reportName: "RETAIL SALE COMP" },
                { id: 7, name: "Land Sale", fileName: "LandSite", reportName: "LAND SALE COMP" },
                { id: 8, name: "Multi-Family", fileName: "RetailSaleSite", reportName: "MULTI-FAMILY COMP COMP" }
            ];


        var compInfo = compsList.find(w => w.id == compType);
        if (!compInfo) {
            compInfo = { id: 0, name: "Invalid Comp Type" };
        }

        const submarket16Options = [{ label: "", value: "" },
        { label: "Clayton", value: "Clayton" },
        { label: "Westport", value: "Westport" },
        { label: "Olive/I-270", value: "Olive/I-270" },
        { label: "Chesterfield", value: "Chesterfield" },
        { label: "Manchester/I-270", value: "Manchester/I-270" },
        { label: "I-44/I-270", value: "I-44/I-270" },
        { label: "Earth City", value: "Earth City" },
        { label: "Airport", value: "Airport" },
        { label: "St. Charles County", value: "St. Charles County" },
        { label: "St. Louis City", value: "St. Louis City" },
        { label: "Metro East", value: "Metro East" },
        { label: "Other", value: "Other" }]

        const submarket34Options = [{ label: "", value: "" },
        { label: "Airport", value: "Airport" },
        { label: "Earth City", value: "Earth City" },
        { label: "Westport", value: "Westport" },
        { label: "St. Louis City", value: "St. Louis City" },
        { label: "Metro East", value: "Metro East" },
        { label: "Mid County", value: "Mid County" },
        { label: "Chesterfield", value: "Chesterfield" },
        { label: "Hanley/Brentwood", value: "Hanley/Brentwood" },
        { label: "Fenton", value: "Fenton" },
        { label: "South County", value: "South County" },
        { label: "North County", value: "North County" },
        { label: "West County", value: "West County" },
        { label: "Jefferson County", value: "Jefferson County" },
        { label: "St. Charles County", value: "St. Charles County" },
        { label: "Other", value: "Other" }]

        const submarket5Options = [{ label: "", value: "" },
        { label: "Airport", value: "Airport" },
        { label: "Chesterfield", value: "Chesterfield" },
        { label: "Clayton", value: "Clayton" },
        { label: "Earth City", value: "Earth City" },
        { label: "Fenton", value: "Fenton" },
        { label: "Franklin County", value: "Franklin County" },
        { label: "Jefferson County", value: "Jefferson County" },
        { label: "Metro East", value: "Metro East" },
        { label: "Mid County", value: "Mid County" },
        { label: "North County", value: "North County" },
        { label: "Northwest County", value: "Northwest County" },
        { label: "Outer St. Louis County", value: "Outer St. Louis County" },
        { label: "South County", value: "South County" },
        { label: "Southwest County", value: "Southwest County" },
        { label: "St. Charles County", value: "St. Charles County" },
        { label: "St. Louis City", value: "St. Louis City" },
        { label: "West County", value: "West County" },
        { label: "Warren County", value: "Warren County" },
        { label: "Other", value: "Other" }
        ]

        const submarket8Options = [{ label: "", value: "" },
        { label: "Downtown", value: "Downtown" },
        { label: "North St. Louis City", value: "North St. Louis City" },
        { label: "South St. Louis City", value: "South St. Louis City" },
        { label: "North County", value: "North County" },
        { label: "West County", value: "West County" },
        { label: "South County", value: "South County" },
        { label: "Mid County", value: "Mid County" },
        { label: "St. Charles County", value: "St. Charles County" },
        { label: "Jefferson County", value: "Jefferson County" },
        { label: "Metro East", value: "Metro East" },
        { label: "Other", value: "Other" }]

        const rateTypeOptions = [{ label: "", value: "" },
        { label: "Full Service", value: "Full Service" },
        { label: "Gross", value: "Gross" },
        { label: "Modified Gross", value: "Modified Gross" },
        { label: "NNN", value: "NNN" }]

        const leaseTypeOptions = [{ label: "", value: "" },
        { label: "New Lease", value: "New Lease" },
        { label: "Sublease", value: "Sublease" },
        { label: "Renewal", value: "Renewal" },
        { label: "Renewal/Expansion", value: "Renewal/Expansion" }]

        //buildingClass
        const buildingClassOptions = [{ label: "", value: "" },
        { label: "A", value: "A" },
        { label: "B", value: "B" },
        { label: "C", value: "C" }]

        const saleTypeOptions = [{ label: "", value: "" },
        { label: "Investment", value: "Investment" },
        { label: "User", value: "User" }]


        const qtrOptions = [{ label: "X", value: "X" },
        { label: "1", value: "1" },
        { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" }]

        const productTypesOptions = [{ label: "", value: "" },
        { label: "MF", value: "MF" },
        { label: "WD", value: "WD" },
        { label: "OS", value: "OS" },
        { label: "Flex", value: "Flex" }]

        const stateOptions = [{ label: "", value: "" },
        { label: "AL", value: "AL" },
        { label: "AK", value: "AK" },
        { label: "AZ", value: "AZ" },
        { label: "AR", value: "AR" },
        { label: "CA", value: "CA" },
        { label: "CO", value: "CO" },
        { label: "CT", value: "CT" },
        { label: "DE", value: "DE" },
        { label: "DC", value: "DC" },
        { label: "FL", value: "FL" },
        { label: "GA", value: "GA" },
        { label: "HI", value: "HI" },
        { label: "ID", value: "ID" },
        { label: "IL", value: "IL" },
        { label: "IN", value: "IN" },
        { label: "IA", value: "IA" },
        { label: "KS", value: "KS" },
        { label: "KY", value: "KY" },
        { label: "LA", value: "LA" },
        { label: "ME", value: "ME" },
        { label: "MD", value: "MD" },
        { label: "MA", value: "MA" },
        { label: "MI", value: "MI" },
        { label: "MN", value: "MN" },
        { label: "MS", value: "MS" },
        { label: "MO", value: "MO" },
        { label: "MT", value: "MT" },
        { label: "NE", value: "NE" },
        { label: "NV", value: "NV" },
        { label: "NH", value: "NH" },
        { label: "NJ", value: "NJ" },
        { label: "NM", value: "NM" },
        { label: "NY", value: "NY" },
        { label: "NC", value: "NC" },
        { label: "ND", value: "ND" },
        { label: "OH", value: "OH" },
        { label: "OK", value: "OK" },
        { label: "OR", value: "OR" },
        { label: "PA", value: "PA" },
        { label: "RI", value: "RI" },
        { label: "SC", value: "SC" },
        { label: "SD", value: "SD" },
        { label: "TN", value: "TN" },
        { label: "TX", value: "TX" },
        { label: "UT", value: "UT" },
        { label: "VT", value: "VT" },
        { label: "VA", value: "VA" },
        { label: "WA", value: "WA" },
        { label: "WV", value: "WV" },
        { label: "WI", value: "WI" },
        { label: "WY", value: "WY" }]
        this.state = {
            addOptions: {},
            compType: compType,
            compName: compInfo.name,
            compInfoObj: compInfo,
            editMode: false,
            compId: compId,
            compFieldOrder: [
                ['leaseCommencement', 'submarket16', 'tenant', 'buildingName', 'address', 'city', 'state',
                    'zip', 'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate',
                    'buildingClass',
                    'tenantRepFirm', 'landlordRepFirm', 'comments', 'source', 'dateEntered'], //1
                ['dateSold', 'submarket16', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'buildingSize', 'perSQFTBS', 'yearBuilt',
                    'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments', 'source', 'pressRelease', 'dateEntered'], //2
                ['leaseCommencement', 'submarket345', 'tenant', 'buildingName', 'address', 'city', 'state', 'zip', 'commencementDate',
                    'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate',
                    'percentOffice', 'lotSize', 'ceilingHeight', 'productType', 'buildingClass', 'tenantRepFirm', 'landlordRepFirm',
                    'comments', 'source', 'pressRelease', 'dateEntered'], //3
                ['dateSold', 'submarket16', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'buildingSize', 'perSQFTBS', 'percentOffice', 'lotSize',
                    'ceilingHeight', 'productType', 'yearBuilt', 'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments',
                    'source', 'pressRelease', 'dateEntered'], //4
                ['leaseCommencement', 'submarket5', 'tenant', 'buildingName', 'address', 'city', 'state', 'zip',
                    'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate',
                    'tenantRepFirm', 'landlordRepFirm',
                    'comments', 'source', 'dateEntered'], //5
                ['dateSold', 'submarket5', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'buildingSize', 'perSQFTBS', 'yearBuilt', 'buyerRepFirm',
                    'sellerRepFirm', 'comments', 'source', 'pressRelease', 'dateEntered'], //6
                ['dateSold', 'submarket16', 'buyer', 'seller', 'address', 'city', 'state',
                    'zip', 'acres', 'acresSQFT', 'salePrice', 'dollarPerAcre', 'dollarPerSQFT', 'buyerRepFirm', 'sellerRepFirm', 'comments',
                    'source', 'pressRelease', 'dateEntered'], //7
                ['dateSold', 'submarket16', 'buyer', 'seller', 'propertyName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'units', 'perUnit', 'capRate', 'perSQFTBS', 'buyerRepFirm', 'sellerRepFirm', 'comments',
                    'source', 'pressRelease', 'dateEntered'] //8
            ],
            reportFieldOrder: [
                ['leaseCommencement', 'submarket16', 'tenant', 'buildingName', 'address', 'city', 'state',
                    'zip', 'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate',
                    'buildingClass', 'tenantRepFirm', 'landlordRepFirm', 'comments'], //1 - Office Lease
                ['dateSold', 'submarket16', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'perSQFTBS',
                    'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments'], //2 - Office Sale
                ['leaseCommencement', 'submarket345', 'tenant', 'buildingName', 'address', 'city', 'state', 'zip', 'commencementDate',
                    'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate',
                    'percentOffice', 'lotSize', 'ceilingHeight', 'productType', 'buildingClass', 'tenantRepFirm', 'landlordRepFirm',
                    'comments'], //3 - Ind. Lease
                ['dateSold', 'submarket16', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'perSQFTBS', 'percentOffice', 'lotSize',
                    'ceilingHeight', 'productType', 'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments',
                    ], //4 - Ind. Sale
                ['leaseCommencement', 'submarket5', 'tenant', 'buildingName', 'address', 'city', 'state', 'zip',
                    'leasedSF', 'term', 'effectiveRate', 'rateType', 'TISF', 'leaseType', 'leaseExpDate', 'buildingClass', 
                    'tenantRepFirm', 'landlordRepFirm',
                    'comments'], //5 - Retail Lease
                ['dateSold', 'submarket5', 'buyer', 'seller', 'buildingName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'occupancyPercent', 'NOI', 'capRate', 'perSQFTBS', 'buildingClass', 'buyerRepFirm',
                    'sellerRepFirm', 'comments'], //6 - Retail Sale
                ['dateSold', 'submarket16', 'buyer', 'seller', 'address', 'city', 'state',
                    'zip', 'acres', 'acresSQFT', 'salePrice', 'dollarPerAcre', 'dollarPerSQFT', 'buyerRepFirm', 'sellerRepFirm', 'comments'], //7 - Land Sale
                ['dateSold', 'submarket16', 'buyer', 'seller', 'propertyName', 'address', 'city', 'state',
                    'zip', 'salePrice', 'saleType', 'units', 'capRate', 'perSQFTBS', 'perUnit', 'buildingClass', 'buyerRepFirm', 'sellerRepFirm', 'comments'] //8 - Multi-Family
            ],
            fieldCompTypes:
                [
                    {
                        fieldName: 'leaseCommencement',
                        validComp: [1, 3, 5],
                        varName: 'leaseCommencement',
                        inputType: "yearQTR",
                        label: "Lease Commencement Date (Year/Qtr)",
                        selectList: qtrOptions,
                        editable: true,
                        reportLabel: "Lease Commencement (Y/Qtr)"
                    },
                    {
                        fieldName: 'dateSold',
                        validComp: [2, 3, 5, 7, 8],
                        varName: 'leaseCommencement',
                        inputType: "yearQTR",
                        label: "Date Sold Year-Qtr [ex: 2010-2]",
                        selectList: qtrOptions,
                        editable: true,
                        reportLabel: "Date of Sale (Year/Qtr)"
                    },
                    {
                        fieldName: 'submarket16',
                        validComp: [1, 6],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket16Options,
                        editable: true
                    },
                    {
                        fieldName: 'TISF',
                        validComp: [1, 6],
                        varName: 'tisf',
                        inputType: "decimal",
                        label: "T.I. / SF",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'submarket345',
                        validComp: [3, 4, 5],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket34Options,
                        editable: true
                    },
                    {
                        fieldName: 'submarket5',
                        validComp: [3, 4, 5],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket5Options,
                        editable: true
                    },
                    {
                        fieldName: 'submarket8',
                        validComp: [8],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: submarket8Options,
                        editable: true
                    },
                    {
                        fieldName: 'tenant',
                        validComp: [1, 3, 5],
                        varName: 'tenant',
                        inputType: "input",
                        label: "Tenant",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'buildingName',
                        validComp: [1, 2, 3, 4, 5, 6],
                        varName: 'buildingName',
                        inputType: "input",
                        label: "Building Name",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'propertyName',
                        validComp: [8],
                        varName: 'buildingName',
                        inputType: "input",
                        label: "Property Name",
                        selectList: null,
                        editable: true,
                        reportLabel: "Property"
                    },
                    {
                        fieldName: 'address',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'address',
                        inputType: "input",
                        label: "Street Address",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'city',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'city',
                        inputType: "input",
                        label: "City",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'state',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'state',
                        inputType: "select",
                        label: "State",
                        selectList: stateOptions,
                        editable: true
                    },
                    {
                        fieldName: 'zip',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'zip',
                        inputType: "input",
                        label: "Zip",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'effectiveRate',
                        validComp: [1, 3, 5],
                        varName: 'effectiveRate',
                        inputType: "currency",
                        label: "Effective Rate",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'leasedSF',
                        validComp: [1, 3, 5],
                        varName: 'leasedSF',
                        inputType: "decimal",
                        label: "Leased SF",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'term',
                        validComp: [1, 3, 5],
                        varName: 'term',
                        inputType: "number",
                        label: "Term (months)",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'rateType',
                        validComp: [1, 3, 5],
                        varName: 'rateType',
                        inputType: "select",
                        label: "Rate Type",
                        selectList: rateTypeOptions,
                        editable: true
                    },
                    {
                        fieldName: 'leaseExpDate',
                        validComp: [1, 3, 5],
                        varName: 'leaseExpDate',
                        inputType: "date",
                        label: "Lease Exp. Date",
                        selectList: rateTypeOptions,
                        editable: true
                    },
                    {
                        fieldName: 'leaseType',
                        validComp: [1, 3, 5],
                        varName: 'leaseType',
                        inputType: "select",
                        label: "Lease Type",
                        selectList: leaseTypeOptions,
                        editable: true
                    },
                    {
                        fieldName: 'buildingOwner',
                        validComp: [1, 3, 5],
                        varName: 'buildingOwner',
                        inputType: "input",
                        label: "Building Owner",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'buildingSize',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'buildingSize',
                        inputType: "decimal",
                        label: "Building Size",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'perSQFT',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'perSQFT',
                        inputType: "currency",
                        label: "Per SQFT",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'perSQFTBS',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'perSQFTBS',
                        inputType: "currency",
                        label: "Per SQFT",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'perUnit',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'perUnit',
                        inputType: "currency",
                        label: "Per Unit",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'yearBuilt',
                        validComp: [1, 2, 3, 4, 5, 6, 8],
                        varName: 'yearBuilt',
                        inputType: "input",
                        label: "Year Built",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'buildingClass',
                        validComp: [1, 2, 3, 4],
                        varName: 'buildingClass',
                        inputType: "select",
                        label: "Building Class",
                        selectList: buildingClassOptions,
                        editable: true
                    },
                    {
                        fieldName: 'tenantRepFirm',
                        validComp: [1, 3, 5],
                        varName: 'tenantRepFirm',
                        inputType: "input",
                        label: "Tenant Rep Firm",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'landlordRepFirm',
                        validComp: [1, 3, 5],
                        varName: 'landlordRepFirm',
                        inputType: "input",
                        label: "Landlord Rep Firm",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'buyer',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'buyer',
                        inputType: "input",
                        label: "Buyer",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'seller',
                        validComp: [2, 4, 6],
                        varName: 'seller',
                        inputType: "input",
                        label: "Seller",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'salePrice',
                        validComp: [2, 4, 6],
                        varName: 'salePrice',
                        inputType: "currency",
                        label: "Sale Price",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'acerage',
                        validComp: [2, 4, 6],
                        varName: 'acerage',
                        inputType: "decimal",
                        label: "Acerage",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'saleType',
                        validComp: [2, 4, 6],
                        varName: 'saleType',
                        inputType: "select",
                        label: "Sale Type",
                        selectList: saleTypeOptions,
                        editable: true
                    },
                    {
                        fieldName: 'buyerRepFirm',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'buyerRepFirm',
                        inputType: "input",
                        label: "Buyer Rep Firm",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'sellerRepFirm',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'sellerRepFirm',
                        inputType: "input",
                        label: "Seller Rep Firm",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'acres',
                        validComp: [7],
                        varName: 'acres',
                        inputType: "decimal",
                        label: "Acreage",
                        selectList: null,
                        editable: true,
                        reportName: "Acres"
                    },
                    {
                        fieldName: 'propertyName',
                        validComp: [8],
                        varName: 'propertyName',
                        inputType: "input",
                        label: "Property Name",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'units',
                        validComp: [8],
                        varName: 'units',
                        inputType: "decimal",
                        label: "Units",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'comments',
                        validComp: [1, 3, 5],
                        varName: 'comments',
                        inputType: "textArea",
                        label: "Comments",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'source',
                        validComp: [1, 3, 5],
                        varName: 'source',
                        inputType: "input",
                        label: "Source",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'NOI',
                        validComp: [1, 3, 5],
                        varName: 'noi',
                        inputType: "input",
                        label: "NOI",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'occupancyPercent',
                        validComp: [1, 3, 5],
                        varName: 'occupancyPercent',
                        inputType: "input",
                        label: "Occupancy %",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'capRate',
                        validComp: [1, 3, 5],
                        varName: 'capRate',
                        inputType: "input",
                        label: "Cap Rate",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'pressRelease',
                        validComp: [1, 3, 5],
                        varName: 'pressRelease',
                        inputType: "textArea",
                        label: "Press Release",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'dateEntered',
                        validComp: [1, 3, 5],
                        varName: 'dateEntered',
                        inputType: "date",
                        label: "Date Entered",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'commencementDate',
                        validComp: [1, 3, 5],
                        varName: 'commencementDate',
                        inputType: "date",
                        label: "Commencement Date",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'percentOffice',
                        validComp: [1, 3, 5],
                        varName: 'percentOffice',
                        inputType: "percent",
                        label: "Percent Office",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'lotSize',
                        validComp: [1, 3, 5],
                        varName: 'lotSize',
                        inputType: "decimal",
                        label: "Lot Size",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'ceilingHeight',
                        validComp: [1, 3, 5],
                        varName: 'ceilingHeight',
                        inputType: "input",
                        label: "Ceiling Height",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'productType',
                        validComp: [1, 3, 5],
                        varName: 'productType',
                        inputType: "select",
                        label: "Product Type",
                        selectList: productTypesOptions,
                        editable: true
                    },
                    {
                        fieldName: 'dollarPerAcre',
                        validComp: [1, 3, 5],
                        varName: 'perAC',
                        inputType: "currency",
                        label: "$ per Acre",
                        selectList: null,
                        editable: true
                    },
                    {
                        fieldName: 'dollarPerSQFT',
                        validComp: [1, 3, 5],
                        varName: 'dollarPerSQFT',
                        inputType: "currency",
                        label: "$ per Square Feet",
                        selectList: null,
                        editable: false
                    },
                    {
                        fieldName: 'acresSQFT',
                        validComp: [1, 3, 5],
                        varName: 'acresSQFT',
                        inputType: "decimal",
                        label: "Square Feet",
                        selectList: null,
                        editable: false
                    }
                ],
            sortedComps: []
        }
        this.checkAuthenticated();
        this.GetComp();
    }

    updateaddOptionsValueByKey = (value, key) => {
        var tempaddOptions = this.state.addOptions;
        tempaddOptions[key] = value;
        this.setState({ addOptions: tempaddOptions })
    }

    async DeleteExisting() {
        if (window.confirm("Are you sure you want to delete this Comp?") === true) {
            const token = Session.getToken();

            const response = await fetch('api/Comps/DeleteComp', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(this.state.addOptions)
            })
            window.location.href = '/Comps/index';
        }
    }

    async BackToList() {
        window.location.href = '/Comps/CompsList?search=1&compType=' + this.state.compType;
    }

    renderFields() {
        let sortList = this.state.compFieldOrder[this.state.compType - 1];
        return sortList.map((fieldName) => {
            let field = this.state.fieldCompTypes.find((field) => field.fieldName == fieldName);
            if (field.varName == "perAC") {
                let perAC = this.state.addOptions.salePrice / this.state.addOptions.acres;
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{perAC != null ? '$' + perAC.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            if (field.varName == "perUnit") {
                let perUnit = this.state.addOptions.salePrice / this.state.addOptions.units;
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{perUnit != null ? perUnit.toLocaleString() : ''}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            if (field.varName == "perSQFT") {
                let calcValue = this.state.addOptions.salePrice / this.state.addOptions.leasedSF;
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{calcValue != null ? '$' + calcValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            if (field.varName == "perSQFTBS") {
                let calcValue = this.state.addOptions.salePrice && this.state.addOptions.buildingSize ? this.state.addOptions.salePrice / this.state.addOptions.buildingSize : null;
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{calcValue != null ? '$' + calcValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            if (field.varName == "dollarPerAcre") {
                let calcVar = this.state.addOptions.salePrice / this.state.addOptions.acres;
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{calcVar != null ? '$' + calcVar.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            if (field.varName == "dollarPerSQFT") {
                let calcVar = this.state.addOptions.salePrice / (this.state.addOptions.acres * 43560);
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{calcVar != null ? '$' + calcVar.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            if (field.varName == "acresSQFT") {
                let calcVar = this.state.addOptions.acres * 43560;
                return (
                    <>
                        <Row className="rowSpacing"  >
                            <Col style={{ textAlign: 'right' }} >
                                <div id="plain">&nbsp;
                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                </div>
                            </Col>
                            <Col>
                                <div id="plain">&nbsp;
                                    <label className="alignRightText">{calcVar}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                );
            }
            return (
                <>
                    {field.editable === true && this.state.editMode === true ? (
                        <>
                            {field.inputType === "yearQTR" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <label className="fromToLabel">Year:</label>
                                                <input type="text"
                                                    name={`${field.varName}Year`}
                                                    value={this.state.addOptions[`${field.varName}Year`] || ''}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, `${field.varName}Year`);
                                                    }}
                                                />
                                            </div>
                                            <div id="plain">&nbsp;
                                                <label className="fromToLabel">QTR:</label>
                                                <select
                                                    options={this.state[field.selectList]}
                                                    closeMenuOnSelect={true}
                                                    hideSelectedOptions={false}
                                                    components={{
                                                        Option
                                                    }}
                                                    name={`${field.varName}QTR`}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, `${field.varName}Qtr`);
                                                    }}
                                                    value={this.state.addOptions[`${field.varName}Qtr`] || ''}
                                                >
                                                    {field.selectList.map(option => {
                                                        return (
                                                            <option key={option.value}>
                                                                {option.label}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {field.inputType === "input" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <input type="text"
                                                    name={field.varName}
                                                    value={this.state.addOptions[field.varName]}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {(field.inputType === "number" || field.inputType === "decimal" || field.inputType === "currency") && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <input type="number"
                                                    name={field.varName}
                                                    value={this.state.addOptions[field.varName]}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}


                            {field.inputType === "select" && (
                                <>
                                    <Row className="rowSpacing">
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <select
                                                    options={this.state[field.selectList]}
                                                    closeMenuOnSelect={true}
                                                    hideSelectedOptions={false}
                                                    components={{
                                                        Option
                                                    }}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                                    }}
                                                    value={this.state.addOptions[field.varName]}
                                                >
                                                    {field.selectList.map(option => {
                                                        return (
                                                            <option key={option.value}>
                                                                {option.label}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {field.inputType === "date" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <input
                                                    type="date"
                                                    value={this.state.addOptions[field.varName] != null ? moment(this.state.addOptions[field.varName], "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD") : ""}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                                    }}
                                                    name={field.varName}
                                                    id={field.varName}
                                                    className="inputSpacing"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {field.inputType === "textArea" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <textarea
                                                    type="textarea"
                                                    value={this.state.addOptions[field.varName]}
                                                    onChange={(e) => {
                                                        this.updateaddOptionsValueByKey(e.target.value, field.varName);
                                                    }}
                                                    name={field.varName}
                                                    id={field.varName}
                                                    className="inputSpacing summaryTextArea"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}

                        </>
                    ) : (
                        <>
                            {field.inputType === "date" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <label className="alignRightText">{this.state.addOptions[field.varName] != null ? moment(this.state.addOptions[field.varName], "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD") : ""}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {field.inputType === "decimal" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <label className="alignRightText">{this.state.addOptions[field.varName] != null ? this.state.addOptions[field.varName].toLocaleString() : ''}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {field.inputType === "currency" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <label className="alignRightText">{this.state.addOptions[field.varName] != null ? '$' + this.state.addOptions[field.varName].toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {field.inputType === "percent" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <label className="alignRightText">{this.state.addOptions[field.varName]}{this.state.addOptions[field.varName] != null ? '%' : ''}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                                )}
                                {field.inputType === "yearQTR" && (
                                    <>
                                        <Row className="rowSpacing"  >
                                            <Col style={{ textAlign: 'right' }} >
                                                <div id="plain">&nbsp;
                                                    <label className="leftLabel alignLeftText">{field.label}</label>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div id="plain">&nbsp;
                                                    <label className="alignRightText">{this.state.addOptions[`${field.varName}Year`] || ''}-{this.state.addOptions[`${field.varName}Qtr`] || ''}</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {field.inputType != "date" && field.inputType != "decimal" && field.inputType != "currency" && field.inputType != "percent" && field.inputType != "yearQTR" && (
                                <>
                                    <Row className="rowSpacing"  >
                                        <Col style={{ textAlign: 'right' }} >
                                            <div id="plain">&nbsp;
                                                <label className="leftLabel alignLeftText">{field.label}</label>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div id="plain">&nbsp;
                                                <label className="alignRightText">{this.state.addOptions[field.varName]}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </>
                    )}

                </>

            );
        });
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isComps = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isComps = await AdminFunctions.isRole("Comps");
            if (!isComps) {
                this.props.history.push('/login');
            }
        }
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    async Add() {
        localStorage.setItem('compsaddOptions', JSON.stringify(this.state.addOptions));

        const token = Session.getToken();
        this.state.addOptions.compType = this.state.compType;
        const response = await fetch('api/Comps/EditComps', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.addOptions)
        });
        const data = await response.json();
        this.setState({ addOptions: data, loading: false, noResults: data.length === 0 ? true : false, editMode: false });
        //How to get - localStorage.getItem();
        //window.location.href = '/Comps/CompsList?search=1&compType=' + this.state.compType;
        //window.open('/Lease/ActiveLeases?search=1', '_self');
    }

    Edit() {
        var temp = JSON.parse(JSON.stringify(this.state.addOptions));
        this.setState({ tempaddOptions: temp, editMode: true });
    }

    Cancel() {
        var temp = JSON.parse(JSON.stringify(this.state.tempaddOptions));
        this.setState({ addOptions: temp, editMode: false });
    }

    async GetComp() {
        const token = Session.getToken();
        const response = await fetch('api/Comps/GetComp?id=' + this.state.compId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        this.setState({ addOptions: data });
    }

    render() {
        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Summary: {this.state.compName}</h3>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row>
                        <Col style={{ textAlign: 'center' }} >
                            <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px", width: "unset" }} onClick={() => {
                                this.PrintSummary();
                            }} >Download Summary</button>
                        </Col>
                    </Row>
                    {this.renderFields()}
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            &nbsp;
                        </Col>
                        <Col>
                            <div id="controls" style={{ textAlign: 'left' }}>
                                {this.state.editMode === true && (
                                    <>

                                        <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                            this.Add();
                                        }} >Save</button>
                                        <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                            this.Cancel();
                                        }} >Cancel</button>
                                    </>
                                )}
                                {this.state.editMode === false && (
                                    <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                        this.Edit();
                                    }} >Edit</button>
                                )}
                                <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                    this.DeleteExisting();
                                }} >Delete</button>
                                <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                    this.BackToList();
                                }} >Back To List</button>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }


    downloadFileText(text, name) {
        const blob = this.textToBlob(text);
        const uriContent = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', uriContent);
        link.setAttribute('download', name);
        const event = new MouseEvent('click');
        link.dispatchEvent(event);
    }

    textToBlob = (text) => {
        const blob = new Blob([text], { type: 'application/rtf' });
        return blob;
    }

    async PrintSummary() {
        this.setState({ loadingDocument: false });
        //Creating a simple text file to start:
        var basicText = this.getBasicText();
        //Get name
        var fileName = this.state.compInfoObj.fileName + "_" + this.state.compId
        this.downloadFileText(basicText, fileName);
        //const data = await response.json();
        //this.setState({ lease: data });
    }

    addBasicText(text, full) {
        return full + text;
    }
    getCell1F(label) {
        var text = "";
        text = text + String.raw`\par \trowd\trql\trleft-108\ltrrow\trpaddft3\trpaddt0\trpaddfl3\trpaddl0\trpaddfb3\trpaddb0\trpaddfr3\trpaddr0\clbrdrt\brdrs\brdrw10\brdrcf4\clbrdrl\brdrs\brdrw10\brdrcf4\clbrdrb\brdrdot\brdrw10\brdrcf4\clbrdrr\brdrs\brdrw10\brdrcf4\clvertalt\cellx2518\clbrdrt\brdrs\brdrw10\brdrcf4\clbrdrl\brdrs\brdrw10\brdrcf4\clbrdrb\brdrdot\brdrw10\brdrcf4\clbrdrr\brdrs\brdrw10\brdrcf4\clvertalt\cellx9250\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\intbl\qr\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf2\kerning1\langfe1033\dbch\af12\afs20\alang1033\rtlch \ltrch\loch\fs18\lang1033\loch\f8` + '\n';

        text = text + label + String.raw`)}\cell\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\intbl\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf1\kerning1\langfe1033\dbch\af15\afs20\alang1033\rtlch \ltrch\loch\fs18\lang1033\loch\f8` + '\n';
        return text;
    }
    getCell2F(value) {
        var text = "";
        text = text + value + String.raw`}\cell\row\pard\trowd\trql\trleft-108\ltrrow\trpaddft3\trpaddt0\trpaddfl3\trpaddl0\trpaddfb3\trpaddb0\trpaddfr3\trpaddr0\clbrdrt\brdrdot\brdrw10\brdrcf4\clbrdrl\brdrs\brdrw10\brdrcf4\clbrdrb\brdrdot\brdrw10\brdrcf4\clbrdrr\brdrs\brdrw10\brdrcf4\clvertalt\cellx2518\clbrdrt\brdrdot\brdrw10\brdrcf4\clbrdrl\brdrs\brdrw10\brdrcf4\clbrdrb\brdrdot\brdrw10\brdrcf4\clbrdrr\brdrs\brdrw10\brdrcf4\clvertalt\cellx9250\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\intbl\qr\nowidctlpar{\cf2\kerning1\langfe1033\dbch\af12\afs20\alang1033\rtlch \ltrch\loch\fs18\lang1033\loch\f8` + '\n';
        return text;
    }

    getCell1M(label) {
        var text = "";
        text = text + String.raw`` + '\n';
        text = text + label + String.raw`}\cell\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\intbl\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf1\kerning1\langfe1033\dbch\af15\afs20\alang1033\rtlch \ltrch\loch\fs18\lang1033\loch\f8` + '\n';
        return text;
    }
    getCell2M(value) {
        var text = "";
        text = text + value + String.raw`}\cell\row\pard\trowd\trql\trleft-108\ltrrow\trpaddft3\trpaddt0\trpaddfl3\trpaddl0\trpaddfb3\trpaddb0\trpaddfr3\trpaddr0\clbrdrt\brdrdot\brdrw10\brdrcf4\clbrdrl\brdrs\brdrw10\brdrcf4\clbrdrb\brdrdot\brdrw10\brdrcf4\clbrdrr\brdrs\brdrw10\brdrcf4\clvertalt\cellx2518\clbrdrt\brdrdot\brdrw10\brdrcf4\clbrdrl\brdrs\brdrw10\brdrcf4\clbrdrb\brdrdot\brdrw10\brdrcf4\clbrdrr\brdrs\brdrw10\brdrcf4\clvertalt\cellx9250\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\intbl\qr\nowidctlpar{\cf2\kerning1\langfe1033\dbch\af12\afs20\alang1033\rtlch \ltrch\loch\fs18\lang1033\loch\f8` + '\n';
        return text;
    }

    getCell1L(label) {
        var text = "";
        text = text + String.raw`` + '\n';
        text = text + label + String.raw`}\cell\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\intbl\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf1\kerning1\langfe1033\dbch\af15\afs20\alang1033\rtlch \ltrch\loch\fs18\lang1033\loch\f8` + '\n';
        return text;
    }
    getCell2L(value) {
        var text = "";
        text = text + value + String.raw`}\cell\row\pard\pard\plain \s21\ql\nowidctlpar\tqc\tx4680\tqr\tx9360\noline\ltrpar\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\ql\widctlpar\tqc\tx4680\tqr\tx9360\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf3\i\kerning1\langfe2052\dbch\af13\afs16\alang1081\ai\rtlch \ltrch\loch\fs16\lang1033\loch\f8` + '\n';
        return text;
    }

    getBasicText() {
        let sortList = this.state.reportFieldOrder[this.state.compType - 1];
        var fieldCompTypes = this.state.fieldCompTypes;
        var text = "";
        var self = this;

        text = text + String.raw`{\rtf1\ansi\deff3\adeflang1025` + '\n';
        text = text + String.raw`{\fonttbl{\f0\froman\fprq2\fcharset0 Times New Roman;}{\f1\froman\fprq2\fcharset2 Symbol;}{\f2\fswiss\fprq2\fcharset0 Arial;}{\f3\froman\fprq2\fcharset0 Times New Roman;}{\f4\froman\fprq0\fcharset1 Times{\*\falt Times New Roman};}{\f5\froman\fprq0\fcharset1 Franklin Gothic Medium;}{\f6\froman\fprq0\fcharset1 Times New Roman;}{\f7\fswiss\fprq0\fcharset1 Arial;}{\f8\froman\fprq0\fcharset1 Arial;}{\f9\fswiss\fprq2\fcharset1 Arial;}{\f10\fnil\fprq2\fcharset0 DejaVu Sans;}{\f11\fnil\fprq2\fcharset0 Arial;}{\f12\fnil\fprq0\fcharset1 Times New Roman (Vietnamese);}{\f13\fnil\fprq0\fcharset1 Lohit Hindi;}{\f14\fnil\fprq0\fcharset1 Times New Roman;}{\f15\fnil\fprq0\fcharset1 Cambria Math;}}` + '\n';
        text = text + String.raw`{\colortbl;\red0\green0\blue0;\red80\green139\blue190;\red128\green128\blue128;\red0\green0\blue1;}` + '\n';
        text = text + String.raw`{\stylesheet{\s0\snext0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033 Normal;}` + '\n';
        text = text + String.raw`{\s15\sbasedon0\snext16\ql\nowidctlpar\sb240\sa120\keepn\ltrpar\cf0\kerning1\dbch\af10\langfe2052\dbch\af13\afs28\alang1081\loch\f7\fs28\lang1033 Heading;}` + '\n';
        text = text + String.raw`{\s16\sbasedon0\snext16\ql\nowidctlpar\sb0\sa120\ltrpar\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033 Text body;}` + '\n';
        text = text + String.raw`{\s17\sbasedon16\snext17\ql\nowidctlpar\sb0\sa120\ltrpar\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033 List;}` + '\n';
        text = text + String.raw`{\s18\sbasedon0\snext18\ql\nowidctlpar\sb120\sa120\noline\ltrpar\cf0\i\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\ai\loch\f6\fs24\lang1033 Caption;}` + '\n';
        text = text + String.raw`{\s19\sbasedon0\snext19\ql\nowidctlpar\noline\ltrpar\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033 Index;}` + '\n';
        text = text + String.raw`{\s20\snext20\ql\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb100\sa115\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe1033\dbch\af13\afs20\alang1033\loch\f4\fs20\lang1033 Normal (Web);}` + '\n';
        text = text + String.raw`{\s21\sbasedon0\snext21\ql\nowidctlpar\tqc\tx4680\tqr\tx9360\noline\ltrpar\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033 Footer;}` + '\n';
        text = text + String.raw`}{\info{\author CR}{\creatim\yr2012\mo10\dy7\hr14\min48}{\revtim\yr2012\mo10\dy7\hr23\min21}{\printim\yr0\mo0\dy0\hr0\min0}{\comment LibreOffice}{\vern3600}}\deftab720\deftab720` + '\n';
        text = text + String.raw`\viewscale108` + '\n';
        text = text + String.raw`{\*\pgdsctbl` + '\n';
        text = text + String.raw`{\pgdsc0\pgdscuse195\pgwsxn12240\pghsxn15840\marglsxn1440\margrsxn1440\margtsxn720\margbsxn1440\pgdscnxt0 Default;}}` + '\n';
        text = text + String.raw`\formshade{\*\pgdscno0}\paperh15840\paperw12240\margl1440\margr1440\margt720\margb1440\sectd\sbknone\sectunlocked1\pgndec\pgwsxn12240\pghsxn15840\marglsxn1440\margrsxn1440\margtsxn720\margbsxn1440\ftnbj\ftnstart1\ftnrstcont\ftnnar\aenddoc\aftnrstcont\aftnstart1\aftnnrlc` + '\n';
        text = text + String.raw`\pgndec\pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf2\kerning1\langfe1033\dbch\af12\afs24\alang1033\rtlch \ltrch\loch\fs24\lang1033\loch\f5` + '\n';
        text = text + this.state.compInfoObj.reportName + String.raw`}` + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0{\cf2\kerning1\langfe1033\dbch\af12\afs24\alang1033\rtlch \ltrch\loch\fs24\lang1033\loch\f5` + '\n';
        text = text + this.state.addOptions['address'].toUpperCase() + String.raw`}` + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        text = text + String.raw`\par \pard\plain \s0\ql\nowidctlpar\ltrpar{\*\hyphen2\hyphlead2\hyphtrail2\hyphmax0}\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\qc\widctlpar\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0\cf1\kerning1\langfe1033\dbch\af14\afs20\alang1033\rtlch \ltrch\loch\fs20\lang1033\loch\f4` + '\n';
        text = text + '\n';
        //Get rows
        for (var i = 0; i < sortList.length; i++) {
            var fieldName = sortList[i];
            let field = fieldCompTypes.find((field) => field.fieldName == fieldName);
            if (field) {
                text = text + self.getTextByField(field, i === 0, i === sortList.length - 1 );
            }
        }
        //End the Table
        //\cell\row\pard\pard\plain \s21\ql\nowidctlpar\tqc\tx4680\tqr\tx9360\noline\ltrpar\cf0\kerning1\dbch\af11\langfe2052\dbch\af13\afs24\alang1081\loch\f6\fs24\lang1033\ql\widctlpar\tqc\tx4680\tqr\tx9360\faauto\li0\ri0\lin0\rin0\fi0\sb101\sa0
        
        text = text + String.raw`The information contained herein was gathered from sources deemed reliable, but no guarantee, express or implied, is made as to the accuracy of the information.}` + '\n';
        text = text + String.raw`\par }`;

        return text;
    }
    getCell1(label, first, last) {
        if (first) {
            return this.getCell1F(label);
        } else if (last) {
            return this.getCell1L(label);
        } else {
            return this.getCell1M(label);
        }
    }

    getCell2(value, first, last) {
        if (first) {
            return this.getCell2F(value);
        } else if (last) {
            return this.getCell2L(value);
        } else {
            return this.getCell2M(value);
        }
    }

    getTextByField(field, first, last) {
        if (field.varName == "perAC") {
            let perAC = this.state.addOptions.salePrice / this.state.addOptions.acres;
            var value = perAC != null ? '$' + perAC.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.varName == "perUnit") {
            let perUnit = this.state.addOptions.salePrice / this.state.addOptions.units;
            var value = perUnit != null ? perUnit.toLocaleString() : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.varName == "perSQFT") {
            let calcValue = this.state.addOptions.salePrice / this.state.addOptions.leasedSF;
            var value = calcValue != null ? '$' + calcValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.varName == "perSQFTBS") {
            let calcValue = this.state.addOptions.salePrice && this.state.addOptions.buildingSize ? this.state.addOptions.salePrice / this.state.addOptions.buildingSize : null;
            var value = calcValue != null ? '$' + calcValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.varName == "dollarPerAcre") {
            let calcVar = this.state.addOptions.salePrice / this.state.addOptions.acres;
            var value = calcVar != null ? '$' + calcVar.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.varName == "dollarPerSQFT") {
            let calcVar = this.state.addOptions.salePrice / (this.state.addOptions.acres * 43560);
            var value = calcVar != null ? '$' + calcVar.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.varName == "acresSQFT") {
            let calcVar = this.state.addOptions.acres * 43560;
            var value = calcVar;
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.inputType === "date") {
            var value = this.state.addOptions[field.varName] != null ? moment(this.state.addOptions[field.varName], "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD") : "";
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.inputType === "decimal") {
            var value = this.state.addOptions[field.varName] != null ? this.state.addOptions[field.varName].toLocaleString() : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }
        if (field.inputType === "currency") {
            var value = this.state.addOptions[field.varName] != null ? '$' + this.state.addOptions[field.varName].toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }      
        if (field.inputType === "percent") {
            var value = this.state.addOptions[field.varName] != null ? '%' : '';
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }         
        if (field.inputType === "yearQTR") {
            var value = (this.state.addOptions[`${field.varName}Year`] || '') + "-" + (this.state.addOptions[`${field.varName}Qtr`] || '');
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        } else {
            var value = this.state.addOptions[field.varName];
            if (field.reportLabel) {
                return this.getCell1(field.reportLabel, first, last) + this.getCell2(value, first, last);
            } else {
                return this.getCell1(field.label, first, last) + this.getCell2(value, first, last);
            }
        }         
    }
}

